import React from 'react';
import {
  SearchOutlined,
  TeamOutlined,
  PlusCircleOutlined,
  DeleteFilled
} from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import {
  Button,
  Col,
  Divider,
  Input,
  Modal,
  Row,
  Select,
  Spin,
  Table,
  Tabs,
  Card,
  Checkbox,
  Badge
} from 'antd';
import Highlighter from 'react-highlight-words';
import Notify from 'src/components/meta/Notification';
import styled from 'styled-components';
import { regExpLiteral } from '@babel/types';
const { Column, ColumnGroup } = Table;
const FormItem = Form.Item;
const { TextArea } = Input;
const { Option } = Select;
const numeral = require('numeral');
const { TabPane } = Tabs;

const StyledTable = styled(Table)`
  .ant-table-thead > tr > th {
    color: #8898aa !important;
    background: #f1f1f1 !important;
  }
  .ant-table-tbody > tr > td {
    border-bottom: 1px solid #f0f0f0;
    transition: background 0.3s;
    font-weight: 500;
    color: #525f7f;
    font-size: 15px;
  }
`;

const StyledBadge = styled(Badge)`
  .ant-badge-status-dot {
    height: 0.6em !important;
    width: 0.6em !important;
  }
`;
const Selection = styled(Select)`
  .ant-select-selection {
    border: 1px solid #bdb2b2;
    height: 45px;
    font-size: 12px;
  }
  .ant-select-selection__placeholder {
    top: 21px;
  }
  .ant-select-selection__rendered {
    height: 44px;
  }
  .ant-select-selection-selected-value {
    position: relative;
    top: 6px;
  }
  .ant-select-selection__rendered:after {
    content: '.';
    display: inline !important;
    visibility: visible !important;
    pointer-events: none;

    width: 0;
  }
`;
const StyledSelect = styled(Select)`
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    position: relative;
    background-color: #ffffff;
    /* border: 1px solid #e9e9e9; */
    height: 45px !important;
    padding: 5px 11px !important;
    border: 1px solid white !important;
    border-radius: 2px;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  }
  .ant-select-multiple .ant-select-selector {
    height: 45px !important;
  }
  border: 1px solid lightgrey;
  border-radius: 0em !important;
  height: 47px !important;
  box-shadow: none !important;
  :hover {
    border-color: red !important;

    box-shadow: none !important;
  }
  :active {
    border-color: red !important;

    box-shadow: none !important;
  }
  :focus {
    border-color: red !important;

    box-shadow: none !important;
  }
  .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input)
    .ant-select-selector {
    border-color: red !important;
    border-right-width: 1px !important;
    outline: 0;
    box-shadow: none !important;
  }
`;
class UserFormClass extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      resetUserPass: false
    };
  }
  render() {
    return (
      <Form layout="vertical">
        <Row>

          <Col span={12} style={{ marginBottom: '-1em' }}>

            <FormItem
              style={{ float: 'right' }}
            // label={<span>Password Reset</span>}
            >
              {this.props.form.getFieldDecorator('firstLogin', {
                // normalize: input => input.toUpperCase(),
                rules: [
                  {
                    required: false,
                    message: 'Please Select a Status'
                  }
                ],
                initialValue: this.props.editUser
                  ? this.state.resetUserPass
                    ? true
                    : this.props.editUser.firstLogin
                  : ''
              })(<Input style={{ display: 'none' }} />)}
            </FormItem>
          </Col>
          <Col span={10} style={{ marginBottom: '-1em' }}>
            <FormItem label={<span>Full Name</span>}>
              {this.props.form.getFieldDecorator('name', {
                rules: [
                  { required: true, message: 'Field entry required' },
                  {
                    //pattern: RegExp(
                    //  /^([a-zA-Z]{2,}\s[a-zA-z]{1,}'?-?[a-zA-Z]{2,}\s?([a-zA-Z]{1,})?)/
                    //),
                    message: 'Entry required'
                  }
                ],
                initialValue: this.props.editUser
                  ? this.props.editUser.name
                  : ''
              })(this.props.editUser ? <Input disabled /> : <Input />)}
            </FormItem>
          </Col>
          <Col span={2} />
          <Col span={10} style={{ marginBottom: '-1em' }}>
            <FormItem label={<span>Number</span>}>
              {this.props.form.getFieldDecorator('number', {
                rules: [
                  { required: true, message: 'User number required' },
                  {
                    pattern: RegExp(/\d/g),
                    message: 'A valid number is required'
                  }
                ],
                initialValue: this.props.editUser
                  ? this.props.editUser.number
                  : ''
              })(
                this.props.editUser ? (
                  <Input maxLength={10} disabled />
                ) : (
                  <Input maxLength={10} />
                )
              )}
            </FormItem>
          </Col>
          <Col span={2} />
          <Col span={10} style={{ marginBottom: '-1em' }}>
            <FormItem label={<span>Email</span>}>
              {this.props.form.getFieldDecorator('email', {
                rules: [
                  {
                    required: true,
                    message: 'Field entry required'
                  },
                  {
                    message: 'Field entry required.'
                  }
                ],
                initialValue: this.props.editUser
                  ? this.props.editUser.email
                  : ''
              })(this.props.editUser ? <Input disabled /> : <Input />)}
            </FormItem>
          </Col>
        </Row>
      </Form>
    );
  }
}
const UserForm = Form.create()(UserFormClass);

function UserFilter(users) {
  return users.name !== 'Initial User';
}
class Users extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      closed: false,
      rejectReason: '',
      editDealer: undefined,
      editManager: undefined,
      editUser: undefined
    };
  }
  componentWillMount = () => {
    // this.setState({ loading: true });
    // this.props
    // .findAllUsers()
    // .then(() => {
    //   this.props
    //     .findAllManagers()
    //     .then(() => {
    //       this.props
    //         .findAllBuyers()
    //         .then(() => {
    //           this.setState({ loading: false });
    //         })
    //     .catch(e => {
    //       this.setState({ loading: false });
    //       Notify('error', e);
    //     });
    // })
    //     .catch(e => {
    //       this.setState({ loading: false });
    //       Notify('error', e);
    //     });
    // })
    // .catch(e => {
    //   this.setState({ loading: false });
    //   Notify('error', e);
    // });
    window.addEventListener('resize', this.resizeEvent);
    if (window.cordova) {
      document.addEventListener('backbutton', this.handleBack);
    }
  };

  handleBack = () => {
    if (this.state.addUserVisible) {
      this.setState({ addUserVisible: false });
    } else {
      this.props.history.goBack();
    }
  };

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.resizeEvent);
    if (window.cordova) {
      document.removeEventListener('backbutton', this.handleBack);
    }
  };

  resizeEvent = () => {
    this.setState({ loading: false });
  };
  userForm;
  onAddUser = e => {
    this.setState({ addUserVisible: true, editUser: undefined });
  };
  handleAddUser = e => {
    e.preventDefault();
    this.userForm.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        values.type = 'user';
        values.password = 'pass';
        values.firstLogin = true;
        // this.setState({ loading: true });
        // if (this.state.editUser) {
        //   values._id = this.state.editUser._id;
        // } else {
        //   values.type = 'user';
        //   values.password = 'pass';
        //   values.firstLogin = true;
        // }
        // values.manager = [values.manager];
        this.props
          .signUpUser(values)
          .then(() => {
            this.props
              .then(() => {
                Notify('success', 'Successfully added user');
                this.userForm.props.form.resetFields();
                this.setState({
                  loading: false,
                  addUserVisible: false,
                  editUser: undefined
                });
              })
              .catch(e => {
                this.setState({ loading: false });
                Notify('error', e);
              });
          })
          .catch(e => {
            this.setState({ loading: false });
            Notify('error', e);
          });
      }
    });
  };


  render() {
    const { user } = this.props;
    return (
      <div style={{ maxWidth: '90em', margin: 'auto' }}>
        <Row
          type="flex"
          justify="start"
          align="middle"
          style={{ textAlign: 'center' }}
        >
        </Row>
        <Spin spinning={this.state.loading}>
          <Tabs style={{ overflow: 'visible' }}>
            <TabPane tab="Users" key="1">
              <Row type="flex" justify="start" align="middle">
                <Modal
                  title="User"
                  visible={true}
                  onOk={this.handleAddUser}
                  onCancel={e => this.setState({ addUserVisible: false })}
                  okText={this.state.editUser ? 'Save' : 'Add User'}
                  cancelText="Cancel"
                >
                  <Col span={24}>
                    <UserForm
                      managers={this.props.managers}
                      editUser={this.state.editUser}
                      wrappedComponentRef={form => (this.userForm = form)}
                    />
                  </Col>
                </Modal>
              </Row>
            </TabPane>

          </Tabs>
        </Spin>


      </div>
    );
  }
}

const WrappedUsers = Form.create()(Users);

export default WrappedUsers;
